export default "__VITE_ASSET__Bio7F0$k__"